import { render, staticRenderFns } from "./unBind.vue?vue&type=template&id=3bb934b2&scoped=true"
import script from "./unBind.vue?vue&type=script&lang=js"
export * from "./unBind.vue?vue&type=script&lang=js"
import style0 from "./unBind.vue?vue&type=style&index=0&id=3bb934b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb934b2",
  null
  
)

export default component.exports